import { StandardEvents } from '@shopify/events';
import { sectionRenderer } from '@theme/section-renderer';

/**
 * Keeps the cart page's item count in sync.
 *
 * Stock Horizon renders the cart title as a block INSIDE main-cart, so the
 * section morph that follows a quantity change refreshes the count for free.
 * This build moves the heading into its own lf-page-title section, which that
 * morph never reaches, leaving "3 items" stale after a stepper click.
 *
 * Re-rendering the title section server-side (rather than patching its text)
 * keeps the count's pluralisation and translation on the Liquid side, where
 * `content.item_count` is defined.
 *
 * Listens for the same CartLinesUpdateEvent the header cart bubble consumes —
 * cart-items-component dispatches it after every /cart/change.js success.
 */

const SECTION_PREFIX = 'shopify-section-';

/** @returns {string | null} The lf-page-title section id, if it is on the page. */
function pageTitleSectionId() {
  const wrapper = document.querySelector('.lf-page-title')?.closest(`[id^="${SECTION_PREFIX}"]`);

  return wrapper?.id ? wrapper.id.slice(SECTION_PREFIX.length) : null;
}

document.addEventListener(StandardEvents.cartLinesUpdate, (event) => {
  const sectionId = pageTitleSectionId();
  if (!sectionId) return;

  const promise = /** @type {any} */ (event).promise;
  if (!promise) return;

  promise
    .then(() => sectionRenderer.renderSection(sectionId, { cache: false, mode: 'full' }))
    .catch((/** @type {any} */ error) => {
      if (error?.name !== 'AbortError') console.warn('[lf-cart] Page title refresh failed:', error);
    });
});
